import React, { useState, useEffect } from 'react';
import { authService } from './utils/auth.ts';
import Home from './pages/Home.tsx';
import Login from './pages/Login.tsx';
import CameraAltIcon from '@mui/icons-material/CameraAlt';

const App: React.FC = () => {
  const [isAuthenticated, setIsAuthenticated] = useState<boolean | null>(null);

  useEffect(() => {
    // 初期認証状態をチェック
    setIsAuthenticated(authService.isAuthenticated());
  }, []);

  const handleLoginSuccess = () => {
    setIsAuthenticated(true);
  };

  // 認証状態の初期化中
  if (isAuthenticated === null) {
    return (
      <div
        style={{
          display: 'flex',
          justifyContent: 'center',
          alignItems: 'center',
          minHeight: '100vh',
          backgroundColor: 'var(--neutral-100)',
        }}
      >
        <div style={{ textAlign: 'center' }}>
          <div style={{ fontSize: '2rem', marginBottom: '1rem' }}>
            <CameraAltIcon style={{ fontSize: '2rem' }} />
          </div>
          <div className="spinner"></div>
        </div>
      </div>
    );
  }

  return (
    <div className="App">
      {isAuthenticated ? (
        <Home />
      ) : (
        <Login onLoginSuccess={handleLoginSuccess} />
      )}
    </div>
  );
};

export default App;
